import React from 'react';
import rawMarkup from '../../util/rawMarkup';


let scriptContent = `
    function OptanonWrapper() {
    	{window.dataLayer.push({event:'OneTrustGroupsUpdated'})} 
    	
    	let c0004 = 8;
     
    	var haveCurrentConsent = /C0004/.test(OptanonActiveGroups);
       	console.log("haveCurrentConsent: " + haveCurrentConsent);
       	
       	if ( haveCurrentConsent == true ) {
		 	c0004=1;
		}
		
		if ( haveCurrentConsent == true ) {
		 	c0004=1;
		}
		
		
		window.onetrustcookies = {
	    	id: c0004,
	    	name: "C004",

		}
		document.getElementById("cookieConsent").innerHTML = c0004;
	
		console.log("user:script-id" + window.onetrustcookies.id);
	
	
	}
`;


const OneTrustScript = () => <script type="text/javascript" dangerouslySetInnerHTML={rawMarkup(scriptContent)} />;
export default OneTrustScript;



// WEBPACK FOOTER //
// ./src/component/Page/OneTrustScript.jsx